import { useEffect, useState } from "react";
import { fetchAdminSelfies } from "@/lib/api";
import { Camera, Fingerprint } from "lucide-react";

export const AdminSelfiesPanel = () => {
  const [selfies, setSelfies] = useState(null);

  useEffect(() => {
    fetchAdminSelfies(48).then((d) => setSelfies(d.selfies || [])).catch(() => setSelfies([]));
  }, []);

  if (!selfies) return null;

  return (
    <section className="glass-card p-5 mt-6" data-testid="admin-selfies-panel">
      <h2 className="font-bold text-lg mb-1 inline-flex items-center gap-2">
        <Camera size={18} className="text-emerald-600" /> Photos de contrôle biométrique
      </h2>
      <p className="text-xs text-[var(--ink-soft)] mb-4">
        Selfies horodatés capturés à l&apos;activation de l&apos;empreinte (référence) et avant chaque paiement (contrôle) — preuve anti-fraude.
      </p>
      {selfies.length === 0 ? (
        <div className="text-sm text-[var(--ink-soft)] py-6 text-center" data-testid="selfies-empty">
          Aucun selfie enregistré pour le moment.
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3">
          {selfies.map((s) => (
            <div key={s.id} className="rounded-xl overflow-hidden border border-[var(--line)] bg-white" data-testid={`selfie-card-${s.id}`}>
              <img src={s.image} alt="" className="w-full aspect-square object-cover" />
              <div className="p-2">
                <span className={`text-[9px] font-bold px-1.5 py-0.5 rounded-full inline-flex items-center gap-1 ${
                  s.kind === "reference" ? "bg-sky-100 text-sky-700" : "bg-emerald-100 text-emerald-700"
                }`}>
                  <Fingerprint size={9} /> {s.kind === "reference" ? "Référence" : "Paiement"}
                </span>
                <div className="text-[10px] font-semibold truncate mt-1">{s.user_name || s.user_email || s.user_phone || s.user_id}</div>
                <div className="text-[9px] text-[var(--ink-soft)]">{(s.created_at || "").slice(0, 16).replace("T", " ")} · {s.ip}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
